var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "well notification-wrapper"
  }, [_vm._l((_vm.list), function(notification, index) {
    return _c('div', {
      staticClass: "panel",
      class: {
        'panel-info': notification.tipo == 'Informazioni' || notification.tipo == 'Informazione', 'panel-danger': notification.tipo == 'Errore', 'panel-warning': notification.tipo == 'Avviso'
      }
    }, [_c('div', {
      staticClass: "media panel-heading"
    }, [_c('div', {
      staticClass: "media-body media-middle"
    }, [_c('div', {
      style: (notification.visual == 'Finestra' ? 'cursor: pointer;' : ''),
      domProps: {
        "innerHTML": _vm._s(notification.content)
      },
      on: {
        "click": function($event) {
          _vm.openFsWindow(notification.id, notification.visual)
        }
      }
    })]), _vm._v(" "), (notification.richiediConferma) ? _c('div', {
      staticClass: "media-right media-middle"
    }, [_c('button', {
      staticClass: "btn btn-default",
      staticStyle: {
        "background-color": "transparent"
      },
      attrs: {
        "id": 'btnConfirmNotif' + notification.id
      },
      on: {
        "click": function($event) {
          _vm.confirmNotification(notification.id)
        }
      }
    }, [_vm._v(_vm._s(_vm.$Jed.translate('Ok')))])]) : _vm._e(), _vm._v(" "), (notification.eliminabile) ? _c('div', {
      staticClass: "media-right media-middle"
    }, [_c('button', {
      staticClass: "btn btn-default",
      staticStyle: {
        "background-color": "transparent"
      },
      on: {
        "click": function($event) {
          _vm.removeNotification(notification)
        }
      }
    }, [_vm._v(_vm._s(_vm.$Jed.translate('Delete')))])]) : _vm._e()])])
  }), _vm._v(" "), (!_vm.list || _vm.list.length == 0) ? _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "media panel-heading"
  }, [_c('div', {
    staticClass: "media-body media-middle"
  }, [_c('div', [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate("there are no pending notifications")))])])])]) : _vm._e()], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a643cb44","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/others/PendingNotifications.vue
// module id = 1529
// module chunks = 1